import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Radio } from '../../../../../../../../CommonComponents/OPL/Radio/Radio';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { WorkflowIdEnum } from '../../../../../../../../Workflow/api/useWorkflowDataQuery';

export const Liquidity = () => {
  const formBag = useFormContext();

  const routeParams = useRouteParams();

  if (routeParams.workflowId !== WorkflowIdEnum.EstatePlanning.toString()) {
    return null;
  }

  const { control } = formBag;

  return (
    <Box>
      <Text as="label" variant="formLabel" color="neutral.600">
        Liquidity Status
      </Text>

      <Box display="flex" flexDirection="column" gridGap="8" mb="8">
        <Box>
          <Controller
            name="bankAccount.IsLiquid"
            control={control}
            render={({ field: { value, name, onChange, disabled } }) => (
              <>
                <Radio
                  name={name}
                  checked={value}
                  disabled={disabled}
                  onChange={() => onChange(true)}
                  mr="4"
                >
                  Liquid
                </Radio>

                <Radio name={name} checked={!value} disabled={disabled} onChange={() => onChange(false)}>
                  Illiquid
                </Radio>
              </>
            )}
          />
        </Box>
      </Box>
    </Box>
  );
};
